// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gdWH","newExpiryDate":"styles_newExpiryDate__E8gjB","footer":"styles_footer__1qtFI"};